import { render, staticRenderFns } from "./newPostPreviewTag.vue?vue&type=template&id=194217d4"
import script from "./newPostPreviewTag.vue?vue&type=script&lang=js"
export * from "./newPostPreviewTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports